module.exports = __webpack_public_path__ + "static/img/share4-2.51458930.png";